module.exports = __webpack_public_path__ + "static/media/need-mental-health.53798ac2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/need/need-mental-health.jpg
// module id = 374
// module chunks = 0